/**
 *
 * Hero Event Description Block
 *
 * Handling animations
 */

jQuery(document).ready(function () {

    jQuery('.animation-holder').each(function (i, animation) {
        var animationIdHolder = animation.id.split('#')[1];
        var currentAnimation = bodymovin.loadAnimation({
            container: document.getElementById(animation.id),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: window.ITBL.assets + '/animations/Animation_data' + animationIdHolder + '.json'
        })
    })

});